import { createAsyncThunk } from "@reduxjs/toolkit";
import { APP_PATH } from "../../api/backendPath";
import { toast } from '../../components/toast';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import i18n from "../../i18n";
// Fetches the list of nurses/technicians (Nurse Management page).
export const fetchNursesReducer = createAsyncThunk(
  "nurseManagement/fetchNurses",
  async ({ status = "All", search = "", page = 1, limit = 10 } = {}, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const queryParamsObj = { page: String(page), limit: String(limit) };
      if (status) queryParamsObj.status = status;
      if (search) queryParamsObj.search = search;
      const queryParams = new URLSearchParams(queryParamsObj).toString();
      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.nurseAvailable}?${queryParams}`;
      const response = await axiosPrivate.get(fullUrl);

      if (response?.data?.status === true || response?.status === 200) {
        return response.data.data;
      } else {
        const msg = response?.data?.message || i18n.t("toast.failedToFetchNurses");
        toast.error(msg);
        return rejectWithValue(msg);
      }
    } catch (error) {
      console.error("Error fetching nurses:", error);
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("toast.errorFetchingNurses");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  }
);
